module.exports = __webpack_public_path__ + "img/people-pants-simple.7ba739ae.svg";